import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";
import {taxonomyListUrl} from "~/pages/taxonomy-builder-v2/services/taxonomyBuilderUrls";

/** Every taxonomy (`GET taxonomy/`), for linking the databag to another one; loaded only when `enabled`. */
export function useTaxonomyListQuery(enabled: boolean) {
    return useCustomQuery({
        queryKey: [taxonomyListUrl()] as const,
        queryFn: async () => (await queryHttp.get<m_taxonomy.SimpleSerializer[]>(taxonomyListUrl())).data,
        enabled,
    });
}
